export default __webpack_public_path__ + "static/media/1949.0af079b1.png";